module.exports = __webpack_public_path__ + "static/img/Roboto-Light.56550f7.svg";